import { PanelBody, Notice } from "@wordpress/components";
import { decodeEntities } from "@wordpress/html-entities";

// See https://developers.google.com/speed/docs/insights/v5/reference/pagespeedapi/runpagespeed#response
export async function googlepagespeedapi(target) {
	const url = setUpQuery(target);
	return await fetch(url)
		.then((response) => response.json())
		.then((json) => {
			console.log(json);
			return json;
		});
}

function setUpQuery(url) {
	const api = "https://www.googleapis.com/pagespeedonline/v5/runPagespeed";
	const parameters = {
		url: encodeURIComponent(url),
	};
	let query = `${api}?`;
	for (let key in parameters) {
		query += `${key}=${parameters[key]}`;
	}
	return query;
}

export async function getDbFileContent(target) {
	if (target === "false") {
		return false;
	}

	return await fetch(target, { cache: "reload" }).then((result) => {
		return result.text();
	});
}

export async function checkServiceRequest() {
	return await fetch(window.ahscUtils.const.homePage)
		.then((response) => {
			let headers = [...response.headers];
			return headers;
		})
		.catch((error) => {
			console.log(error);
			return false;
		});
}

export function ServiceBanner(props) {
	//@see https://github.com/WordPress/gutenberg/tree/f53aefdb20cf5f69767bd8106d8d57f9e5e08cb0/packages/components/src/notice
	return (
		<Notice id={props.notice.handle} status={props.notice.type} isDismissible={false}>
			<p dangerouslySetInnerHTML={{ __html: props.notice.message }}></p>
		</Notice>
	);
}
